import { type FunctionalComponent, h } from '@stencil/core'
import { AccountPanel, type AccountPanelProps } from './AccountPanel'
import { ItemsPanel, type ItemsPanelProps } from './ItemsPanel'
import { WidgetPanel, type WidgetPanelProps } from './WidgetPanel'

export interface AllInOnePanelProps extends AccountPanelProps, ItemsPanelProps, WidgetPanelProps {}

export const AllInOnePanel: FunctionalComponent<AllInOnePanelProps> = ({
  accountsData,
  selectedAccount,
  onSelectAccount,
  onRefreshAccounts,
  itemsData,
  selectedItem,
  onSelectItem,
  onRefreshItems,
  isLoadingAccount,
  isLoadingAccounts,
  isLoadingItems,
  accountsError,
  itemsError,
  statusMessage,
  widgetType,
  widgetView,
  onWidgetTypeChange,
  onWidgetViewChange,
  favoritesOnly,
  favoritesAccountsData,
  onToggleFavorite,
  debugConfig
}) => {
  return (
    <div class="debug-toolbar-panel open">
      <div class="debug-toolbar-section flex flex-col gap-4">
        <div>
          <AccountPanel
            accountsData={accountsData}
            selectedAccount={selectedAccount}
            onSelectAccount={onSelectAccount}
            onRefreshAccounts={onRefreshAccounts}
            isLoadingAccount={isLoadingAccount}
            isLoadingAccounts={isLoadingAccounts}
            accountsError={accountsError}
            favoritesOnly={favoritesOnly}
            favoritesAccountsData={favoritesAccountsData}
            onToggleFavorite={onToggleFavorite}
            debugConfig={debugConfig}
          />
        </div>
        <div>
          <ItemsPanel
            itemsData={itemsData}
            selectedItem={selectedItem}
            onSelectItem={onSelectItem}
            onRefreshItems={onRefreshItems}
            isLoadingAccount={isLoadingAccount}
            isLoadingItems={isLoadingItems}
            itemsError={itemsError}
            statusMessage={statusMessage}
          />
        </div>
        <div>
          <WidgetPanel
            widgetType={widgetType}
            widgetView={widgetView}
            onWidgetTypeChange={onWidgetTypeChange}
            onWidgetViewChange={onWidgetViewChange}
          />
        </div>
      </div>
    </div>
  )
}
